/* SUMMIT theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var S = window.Summit || {};
  var routes = S.routes || {};
  var root = (routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = S.moneyFormat || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var n = (Number(cents) || 0) / 100;
    function withDelims(num, dec, th, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = withDelims(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = withDelims(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(n, 0, '.', ','); break;
      default: v = withDelims(n, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  S.formatMoney = formatMoney;

  /* ---------- Header / mobile menu ---------- */
  var menu = document.querySelector('[data-mobile-menu]');
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t && menu) {
      var open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      document.body.classList.toggle('no-scroll', open);
      document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart_url || '/cart'; return; }
    drawer.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var c = drawer.querySelector('[data-drawer-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }
  S.openDrawer = openDrawer;

  function renderSections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html && drawer) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-drawer-inner]');
      var cur = drawer.querySelector('[data-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      var countEl = doc.querySelector('[data-drawer-count]');
      if (countEl) updateCount(Number(countEl.getAttribute('data-drawer-count')));
    }
  }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.setAttribute('data-count', n);
    });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: 'cart-drawer', sections_url: window.location.pathname }, body))
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  /* ---------- "Added to cart" notice (no page dimming) ---------- */
  var toastEl, toastTimer;
  function showAdded(items) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var added = items.reduce(function (a, i) { return a + (Number(i.quantity) || 1); }, 0);
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'added-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
        toastEl.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
        toastEl.addEventListener('mouseleave', function () { toastTimer = setTimeout(hideAdded, 3000); });
        toastEl.addEventListener('click', function (e) { if (e.target.closest('[data-toast-close]')) hideAdded(); });
      }
      toastEl.innerHTML =
        '<div class="added-toast__head"><span class="added-toast__check" aria-hidden="true">✓</span>' +
        '<strong>' + (added > 1 ? added + ' items added to cart' : 'Added to cart') + '</strong>' +
        '<button type="button" class="added-toast__x" data-toast-close aria-label="Close">×</button></div>' +
        '<p class="added-toast__sub">' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your cart · ' + formatMoney(cart.total_price) + '</p>' +
        '<div class="added-toast__btns"><a class="btn btn--sm btn--ghost" href="' + (routes.cart_url || '/cart') + '">View cart</a>' +
        '<a class="btn btn--sm btn--ember" href="' + root + 'checkout">Check out</a></div>';
      toastEl.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hideAdded, 6000);
    });
  }
  function hideAdded() { if (toastEl) toastEl.classList.remove('is-visible'); }

  S.addItems = function (items) {
    return cartRequest(root + 'cart/add.js', { items: items }).then(function (res) {
      renderSections(res.sections); showAdded(items); return res;
    });
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); if (menu && menu.classList.contains('is-open')) { menu.classList.remove('is-open'); document.body.classList.remove('no-scroll'); } }
  });

  // Line quantity changes (drawer + cart page)
  function changeLine(line, qty, scope) {
    scope && scope.classList.add('is-loading');
    return cartRequest(root + 'cart/change.js', { line: Number(line), quantity: qty })
      .then(function (res) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        renderSections(res.sections);
      })
      .catch(function () { window.location.reload(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-step]');
    if (b) {
      e.preventDefault();
      var wrap = b.closest('[data-line]');
      var input = wrap.querySelector('input');
      var q = Math.max(0, Number(input.value) + Number(b.getAttribute('data-line-step')));
      changeLine(wrap.getAttribute('data-line'), q, wrap);
    }
    var r = e.target.closest('[data-line-remove]');
    if (r) { e.preventDefault(); var w = r.closest('[data-line]'); changeLine(w.getAttribute('data-line'), 0, w); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line] input[type=number]');
    if (input) { var w = input.closest('[data-line]'); changeLine(w.getAttribute('data-line'), Math.max(0, Number(input.value)), w); }
  });

  // Hybrid system cards: optional heat strip updates total + items
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-hsys-kit]');
    if (!sel) return;
    var card = sel.closest('.hsys__card');
    var totalEl = card.querySelector('[data-hsys-total]'), btn = card.querySelector('[data-hsys-base]');
    var total = Number(totalEl.getAttribute('data-base')), items = btn ? JSON.parse(btn.getAttribute('data-hsys-base')) : [];
    card.querySelectorAll('[data-hsys-kit]').forEach(function (s) {
      var o = s.options[s.selectedIndex];
      total += Number(o.getAttribute('data-price') || 0);
      if (s.value) items.push({ id: Number(s.value), quantity: 1 });
    });
    totalEl.textContent = formatMoney(total);
    if (btn) btn.setAttribute('data-add-items', JSON.stringify(items));
    var link = sel.getAttribute('data-hsys-link') && document.getElementById(sel.getAttribute('data-hsys-link'));
    if (link) link.href = sel.options[sel.selectedIndex].getAttribute('data-url') || link.getAttribute('data-default');
  });

  // One-click multi-item add (e.g. hybrid air handler + condenser)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-items]');
    if (!b) return;
    e.preventDefault();
    var items; try { items = JSON.parse(b.getAttribute('data-add-items')); } catch (err) { return; }
    var label = b.innerHTML; b.setAttribute('aria-disabled', 'true'); b.textContent = 'Adding…';
    S.addItems(items)
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
      .finally(function () { b.removeAttribute('aria-disabled'); b.innerHTML = label; });
  });

  // AJAX product forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    S.addItems([item])
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; } });
  });

  // Quantity steppers on product page
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(b.getAttribute('data-qty-step')));
  });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }
  // Safety net: anything already on screen (or everything, if observers stall) becomes visible
  function revealVisible() {
    revealEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
    });
  }
  requestAnimationFrame(revealVisible);
  window.addEventListener('load', revealVisible);
  window.addEventListener('scroll', function () { requestAnimationFrame(revealVisible); }, { passive: true });
  // Theme editor: always show
  if (window.Shopify && window.Shopify.designMode) revealEls.forEach(function (el) { el.classList.add('is-in'); });

  /* ---------- Rails ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail-dir]');
    if (!b) return;
    var rail = document.getElementById(b.getAttribute('aria-controls'));
    if (!rail) return;
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 16 : 320;
    rail.scrollBy({ left: step * Number(b.getAttribute('data-rail-dir')), behavior: 'smooth' });
  });

  /* ---------- Product gallery + variants ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('[data-thumb]');
    function show(i) {
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.setAttribute('aria-current', idx === i); });
    }
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
    g._show = function (mediaId) {
      slides.forEach(function (s, idx) { if (s.getAttribute('data-media-id') === String(mediaId)) show(idx); });
    };
  });

  document.querySelectorAll('[data-product]').forEach(function (p) {
    var dataEl = p.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = p.querySelector('input[name=id]');
    var priceEl = p.querySelector('[data-price]');
    var btn = p.querySelector('[data-add-btn]');
    var gallery = document.querySelector('[data-gallery]');
    p.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = Array.prototype.map.call(p.querySelectorAll('[data-option-group]'), function (grp) {
        var c = grp.querySelector('input:checked'); return c ? c.value : null;
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (btn) {
        if (v.available) { btn.removeAttribute('aria-disabled'); btn.textContent = 'Add to cart'; }
        else { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Sold out'; }
      }
      if (v.featured_media && gallery && gallery._show) gallery._show(v.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Sticky buy bar
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-add-btn]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  /* ---------- BTU sizing calculator ---------- */
  document.querySelectorAll('[data-calc]').forEach(function (calc) {
    var sizes = JSON.parse(calc.querySelector('[data-calc-sizes]').textContent);
    var products = JSON.parse(calc.querySelector('[data-calc-products]').textContent);
    var range = calc.querySelector('input[type=range]');
    var out = calc.querySelector('[data-calc-sqft]');
    var big = calc.querySelector('[data-calc-big]');
    var label = calc.querySelector('[data-calc-label]');
    var card = calc.querySelector('[data-calc-card]');
    var multi = calc.querySelector('[data-calc-multi]');
    function val(name) { var c = calc.querySelector('input[name="' + name + '"]:checked'); return c ? Number(c.value) : 1; }
    function run() {
      var sq = Number(range.value);
      out.textContent = sq.toLocaleString() + ' sq ft';
      range.style.setProperty('--fill', ((sq - range.min) / (range.max - range.min) * 100) + '%');
      var eff = sq * val('ceiling') * val('climate') * val('envelope');
      var pick = null;
      for (var i = 0; i < sizes.length; i++) { if (eff <= sizes[i].max) { pick = sizes[i]; break; } }
      if (!pick) {
        big.innerHTML = 'Multi<small>zone</small>';
        label.textContent = 'That much space is best served by a multi-zone system — one outdoor unit, a head in each room.';
        card.hidden = true; if (multi) multi.hidden = false;
        return;
      }
      if (multi) multi.hidden = true;
      big.innerHTML = pick.btu + 'K<small>BTU</small>';
      label.textContent = 'Recommended for about ' + Math.round(eff).toLocaleString() + ' sq ft of effective load (' + pick.range + ' rated coverage).';
      var prod = products.find(function (p) { return Number(p.btu) === Number(pick.btu); });
      if (prod) {
        card.hidden = false;
        card.href = prod.url;
        card.querySelector('img').src = prod.image;
        card.querySelector('[data-t]').textContent = prod.title;
        card.querySelector('[data-p]').textContent = formatMoney(prod.price) + ' · ' + prod.volts;
      } else { card.hidden = true; }
    }
    calc.addEventListener('input', run);
    calc.addEventListener('change', run);
    run();
  });

  /* ---------- System builder (single-zone kit or multi-zone wizard) ---------- */
  document.querySelectorAll('[data-builder]').forEach(function (b) {
    var data = JSON.parse(b.querySelector('[data-builder-json]').textContent);
    var MATCH = JSON.parse(b.querySelector('[data-mz-matchups]').textContent);
    var hybEl = b.querySelector('[data-mz-hybrid]');
    var HYB = hybEl ? JSON.parse(hybEl.textContent) : {};
    var COVER = { 6: 200, 9: 400, 12: 550, 18: 800, 24: 1050, 36: 1550 };
    var SIZES = [6, 9, 12, 18, 24, 36];
    var LINE_SIZE = { 6: '1/4 x 3/8', 9: '1/4 x 3/8', 12: '1/4 x 3/8', 18: '1/4 x 1/2', 24: '3/8 x 5/8', 36: '3/8 x 5/8' };
    var LENGTHS = [16, 25, 35, 50];
    var ROOM_NAMES = ['Living room', 'Primary bedroom', 'Bedroom 2', 'Office', 'Kitchen', 'Bonus room'];
    var $ = function (s) { return b.querySelector(s); };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var money = formatMoney;
    var X = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    data.condensers.forEach(function (c) { var m = MATCH[c.sku] || {}; c.combos = m.combos || []; c.maxLine = m.maxLine || 0; });
    data.condensers.sort(function (x, y) { return x.btu - y.btu; });
    (data.bundles || []).sort(function (x, y) { return x.btu - y.btu; });
    data.accessories = data.accessories || [];

    var state = {
      step: 1,
      rooms: [{ name: ROOM_NAMES[0], sq: 450 }, { name: ROOM_NAMES[1], sq: 250 }],
      cond: null, bundle: null,
      units: [], lines: [],
      acc: {}   // variantId -> qty
    };
    var linesOk = true;

    function single() { return state.rooms.length === 1; }
    function seq() { return single() ? [1, 2, 5, 6] : [1, 2, 3, 4, 5, 6]; }
    function nextOf(n) { var s = seq(); return s[s.indexOf(n) + 1]; }
    function zonesCount() { return single() ? 1 : state.rooms.length; }

    /* --- sizing helpers --- */
    function factor() {
      var c = b.querySelector('input[name=mz-ceiling]:checked'), k = b.querySelector('input[name=mz-climate]:checked');
      return (c ? Number(c.value) : 1) * (k ? Number(k.value) : 1);
    }
    function need(room) {
      var eff = (Number(room.sq) || 0) * factor();
      for (var i = 0; i < SIZES.length; i++) if (COVER[SIZES[i]] >= eff) return SIZES[i];
      return 36;
    }
    function oversize(room) { return (Number(room.sq) || 0) * factor() > COVER[36]; }
    function handler(btu, kind) { return data.handlers.find(function (h) { return h.btu === btu && h.kind === kind; }); }
    function hasKind(btu, kind) { return !!handler(btu, kind); }
    function comboKey(sizes) { return sizes.slice().sort(function (a, c) { return a - c; }).join('+'); }
    function approved(cond, sizes) { return cond && cond.combos.indexOf(comboKey(sizes)) > -1; }
    // A DIY Hybrid (ducted) zone is checked against MRCOOL's separate Hybrid match-up sheet; one per system.
    function approvedUnits(cond, units) {
      var sizes = units.map(function (u) { return u.btu; });
      var ducted = units.filter(function (u) { return u.kind === 'ducted'; });
      if (!ducted.length) return approved(cond, sizes);
      if (!cond || ducted.length > 1) return false;
      var list = (HYB[cond.sku] || {})[String(ducted[0].btu)] || [];
      return list.indexOf(comboKey(sizes)) > -1;
    }
    function hybridConds() { return data.condensers.filter(function (c) { return HYB[c.sku]; }).map(function (c) { return c.btu + 'K'; }); }
    function fit(cond, needs) {
      if (needs.length > cond.zones) return { reason: 'Runs up to ' + cond.zones + ' rooms' };
      var nd = needs.slice().sort(function (a, c) { return c - a; }), best = null;
      cond.combos.forEach(function (k) {
        var cs = k.split('+').map(Number).sort(function (a, c) { return c - a; });
        if (cs.length !== nd.length) return;
        for (var i = 0; i < cs.length; i++) if (cs[i] < nd[i]) return;
        var sum = cs.reduce(function (a, c) { return a + c; }, 0);
        if (!best || sum < best.sum) best = { sizes: cs, sum: sum };
      });
      if (!best) return { reason: 'No MRCOOL-approved combo for these room sizes' };
      var order = needs.map(function (n, i) { return i; }).sort(function (a, c) { return needs[c] - needs[a]; });
      var assigned = []; order.forEach(function (ri, j) { assigned[ri] = best.sizes[j]; });
      return { sizes: assigned, sum: best.sum };
    }
    function lineFor(btu, len, cable) { return data.linesets.find(function (l) { return l.size === LINE_SIZE[btu] && l.len === len && l.cable === cable; }); }
    function lineOpts(btu, len) { return { plain: lineFor(btu, len, false), cable: lineFor(btu, len, true) }; }
    function defaultLine(btu) {
      var o = lineOpts(btu, 25);
      if (o.cable) return { len: 25, cable: true };
      if (o.plain) return { len: 25, cable: false };
      for (var i = 0; i < LENGTHS.length; i++) { o = lineOpts(btu, LENGTHS[i]); if (o.cable || o.plain) return { len: LENGTHS[i], cable: !!o.cable }; }
      return { len: 0, cable: false };
    }
    function kindLabel(k) { return k === 'cassette' ? 'Ceiling cassette' : k === 'ducted' ? 'Ducted Hybrid™' : 'Wall-mount'; }

    /* --- accessories --- */
    function accRecommended(a) {
      if (a.role === 'cover') return true;
      if (single() && state.bundle) {
        if (a.role === 'bracket-small') return state.bundle.btu <= 18;
        if (a.role === 'bracket-large') return state.bundle.btu >= 24;
      }
      return false;
    }
    function accVisible(a) {
      if (a.role === 'bracket-small' || a.role === 'bracket-large') return single() && accRecommended(a);
      return true;
    }
    function accNote(a) {
      if (a.role === 'cover') return 'Recommended · 1 kit per line run (' + zonesCount() + ')';
      if (a.role === 'bracket-small' || a.role === 'bracket-large') return 'Fits your ' + state.bundle.btu + 'K condenser';
      return '';
    }
    function accDefaultQty(a) { return a.role === 'cover' ? zonesCount() : 1; }

    /* --- the cart list, shared by summary + review --- */
    function lineItems() {
      var list = [];
      function push(key, label, v, qty, img, url) {
        var ex = list.find(function (x) { return x.id === v.id; });
        if (ex) { ex.qty += qty; return; }
        list.push({ id: v.id, label: label, price: v.price, qty: qty, image: img || v.image, url: url || v.url });
      }
      if (single()) {
        if (state.bundle) push('b', state.bundle.btu + 'K single-zone kit (' + state.bundle.volts + ')', state.bundle, 1);
      } else {
        if (state.cond) push('c', state.cond.btu + 'K ' + state.cond.zones + '-zone condenser', state.cond, 1);
        if (state.step >= 3) state.units.forEach(function (u) { var h = handler(u.btu, u.kind); if (h) push('h', u.btu + 'K ' + kindLabel(u.kind).toLowerCase() + ' air handler', h, 1); });
        if (state.step >= 4) state.lines.forEach(function (L, i) {
          var l = L.len ? lineFor(state.units[i].btu, L.len, L.cable) : null;
          if (l) push('l', L.len + ' ft ' + LINE_SIZE[state.units[i].btu] + ' line set' + (L.cable ? ' + DIYPRO® cable' : ''), l, 1);
        });
      }
      data.accessories.forEach(function (a) { var q = state.acc[a.id]; if (q && accVisible(a)) push('a', a.title, a, q); });
      return list;
    }

    /* --- navigation --- */
    function go(n) {
      state.step = n;
      var s = seq(), idx = s.indexOf(n);
      b.querySelectorAll('[data-wstep]').forEach(function (el) {
        var k = Number(el.getAttribute('data-wstep')), pos = s.indexOf(k);
        el.hidden = pos === -1;
        el.classList.toggle('is-active', k === n);
        el.classList.toggle('is-done', pos > -1 && pos < idx);
        el.classList.toggle('is-locked', pos > idx);
        el.querySelector('.wstep__head').disabled = pos >= idx;
      });
      $('[data-num5]').textContent = single() ? '03' : '05';
      $('[data-num6]').textContent = single() ? '04' : '06';
      render();
      if (n > 1) { var act = b.querySelector('[data-wstep="' + n + '"]'); var top = act.getBoundingClientRect().top + window.scrollY - 90; window.scrollTo({ top: top, behavior: 'smooth' }); }
    }

    /* --- step 1 --- */
    function renderRooms() {
      $('[data-rooms]').innerHTML = state.rooms.map(function (r, i) {
        return '<div class="room">' +
          '<input class="input" type="text" value="' + esc(r.name) + '" data-room="' + i + '" data-k="name" aria-label="Room ' + (i + 1) + ' name">' +
          '<label class="room__sq"><input class="input" type="number" min="50" max="3000" step="10" inputmode="numeric" value="' + (r.sq || '') + '" data-room="' + i + '" data-k="sq" aria-label="Room ' + (i + 1) + ' square feet"><span>sq ft</span></label>' +
          '<span class="room__need" title="Recommended size">' + (r.sq ? need(r) + 'K' : '—') + '</span>' +
          '<button type="button" class="zone__remove" data-remove-room="' + i + '" aria-label="Remove room"' + (state.rooms.length <= 1 ? ' hidden' : '') + '>' + X + '</button>' +
          (oversize(r) ? '<p class="room__warn">Over 1,550 sq ft — consider splitting this space into two zones.</p>' : '') +
          '</div>';
      }).join('');
      $('[data-add-room]').hidden = state.rooms.length >= 6;
      var ok = state.rooms.every(function (r) { return Number(r.sq) > 0; });
      $('[data-next="2"]').disabled = !ok;
      $('[data-step1-msg]').textContent = !ok ? 'Enter square footage for each room.'
        : single() ? '1 room → single-zone kit' : state.rooms.length + ' rooms → multi-zone · ' + state.rooms.map(need).map(function (x) { return x + 'K'; }).join(' + ');
      $('[data-sum="1"]').textContent = state.rooms.length + (single() ? ' room · ' : ' rooms · ') + state.rooms.reduce(function (a, r) { return a + (Number(r.sq) || 0); }, 0).toLocaleString() + ' sq ft';
    }

    /* --- step 2 --- */
    function renderStep2() {
      var el = $('[data-cond-options]');
      if (single()) {
        $('[data-title2]').textContent = 'Your single-zone kit';
        $('[data-intro2]').textContent = 'One room is a job for a single-zone kit — condenser, air handler, 25 ft pre-charged line set, DIYPRO® cable and remote, all in one box.';
        var n = need(state.rooms[0]), rec = data.bundles.find(function (x) { return x.btu >= n && x.available; }) || data.bundles[data.bundles.length - 1];
        if (!state.bundle) state.bundle = rec;
        el.innerHTML = data.bundles.map(function (k, i) {
          var small = k.btu < n;
          return '<div class="option"><input type="radio" name="mz-kit" id="mzk-' + i + '" value="' + k.id + '"' + (k.available ? '' : ' disabled') + (state.bundle && state.bundle.id === k.id ? ' checked' : '') + '>' +
            '<label for="mzk-' + i + '">' + (k === rec ? '<span class="badge badge--ember option__flag">Recommended</span>' : '') +
            (k.image ? '<img class="option__img" src="' + k.image + '" alt="" loading="lazy">' : '') +
            '<span class="option__big">' + k.btu + 'K<small>BTU</small></span>' +
            '<span class="option__meta">' + k.volts + ' · complete kit</span>' +
            (small ? '<span class="option__fit option__fit--no">Undersized for ' + esc(state.rooms[0].name) + '</span>' : '<span class="option__fit">✓ Covers ' + (Number(state.rooms[0].sq) || 0).toLocaleString() + ' sq ft</span>') +
            '<span class="option__price">' + money(k.price) + '</span></label></div>';
        }).join('');
        $('[data-next="3"]').disabled = !state.bundle;
        $('[data-next="3"]').textContent = 'Add accessories';
        $('[data-sum="2"]').textContent = state.bundle ? state.bundle.btu + 'K kit · ' + state.bundle.volts : '';
        return;
      }
      $('[data-title2]').textContent = 'Pick your condenser';
      $('[data-intro2]').textContent = "Every option is checked against MRCOOL's approved multi-zone matchups for your rooms.";
      $('[data-next="3"]').textContent = 'Choose air handlers';
      var needs = state.rooms.map(need), cheapest = null;
      data.condensers.forEach(function (c) { c._fit = fit(c, needs); if (c._fit.sizes && c.available && (!cheapest || c.price < cheapest.price)) cheapest = c; });
      if (!data.condensers.some(function (c) { return c._fit.sizes; })) {
        el.innerHTML = '<p class="notice">No single MRCOOL DIY® 5th Gen condenser is approved for this mix of rooms. Try fewer rooms, or send us your floor plan and we\'ll suggest a split.</p>';
      } else {
        el.innerHTML = data.condensers.map(function (c, i) {
          var f = c._fit, ok = !!f.sizes && c.available, bumped = ok && f.sizes.some(function (s, j) { return s > needs[j]; });
          return '<div class="option"><input type="radio" name="mz-cond" id="mzc-' + i + '" value="' + c.id + '"' + (ok ? '' : ' disabled') + (state.cond && state.cond.id === c.id ? ' checked' : '') + '>' +
            '<label for="mzc-' + i + '">' + (c === cheapest ? '<span class="badge badge--ember option__flag">Recommended</span>' : '') +
            '<span class="option__big">' + c.btu + 'K<small>BTU</small></span>' +
            '<span class="option__meta">Up to ' + c.zones + ' zones · 230V</span>' +
            (ok ? '<span class="option__fit">✓ Runs ' + f.sizes.map(function (s) { return s + 'K'; }).join(' + ') + '</span>' + (bumped ? '<span class="option__meta">Some rooms upsized to an approved combo</span>' : '')
                : '<span class="option__fit option__fit--no">' + (c.available ? f.reason : 'Sold out') + '</span>') +
            '<span class="option__price">' + money(c.price) + '</span></label></div>';
        }).join('');
      }
      if (state.cond && !(state.cond._fit && state.cond._fit.sizes)) state.cond = null;
      $('[data-next="3"]').disabled = !state.cond;
      $('[data-sum="2"]').textContent = state.cond ? state.cond.btu + 'K · ' + state.cond.zones + '-zone condenser' : '';
    }

    /* --- step 3 --- */
    function renderHandlers() {
      var needs = state.rooms.map(need);
      $('[data-handlers]').innerHTML = state.rooms.map(function (r, i) {
        var u = state.units[i], h = handler(u.btu, u.kind);
        var sizeOpts = SIZES.filter(function (s) { return hasKind(s, 'wall') || hasKind(s, 'cassette') || hasKind(s, 'ducted'); }).map(function (s) {
          return '<option value="' + s + '"' + (s === u.btu ? ' selected' : '') + '>' + s + 'K BTU</option>';
        }).join('');
        return '<div class="zone zone--4">' +
          '<span class="zone__name">' + esc(r.name) + '<small>' + (Number(r.sq) || 0).toLocaleString() + ' sq ft · needs ' + needs[i] + 'K+</small></span>' +
          '<div class="select"><select data-unit="' + i + '" data-k="btu" aria-label="' + esc(r.name) + ' size">' + sizeOpts + '</select></div>' +
          '<div class="seg seg--sm">' +
            '<input type="radio" id="k' + i + 'w" name="kind' + i + '" value="wall" data-unit="' + i + '" data-k="kind"' + (u.kind === 'wall' ? ' checked' : '') + (hasKind(u.btu, 'wall') ? '' : ' disabled') + '><label for="k' + i + 'w">Wall-mount</label>' +
            '<input type="radio" id="k' + i + 'c" name="kind' + i + '" value="cassette" data-unit="' + i + '" data-k="kind"' + (u.kind === 'cassette' ? ' checked' : '') + (hasKind(u.btu, 'cassette') ? '' : ' disabled') + '><label for="k' + i + 'c">Ceiling cassette</label>' +
            (data.handlers.some(function (h) { return h.kind === 'ducted'; }) ? '<input type="radio" id="k' + i + 'd" name="kind' + i + '" value="ducted" data-unit="' + i + '" data-k="kind"' + (u.kind === 'ducted' ? ' checked' : '') + '><label for="k' + i + 'd" title="DIY Hybrid air handler on existing ductwork (24K or 36K)">Ducted</label>' : '') +
          '</div>' +
          '<span class="zone__price">' + (h ? money(h.price) : '—') + '</span>' +
          (u.btu < needs[i] ? '<p class="room__warn">Smaller than recommended for this room.</p>' : '') +
          '</div>';
      }).join('');
      var sizes = state.units.map(function (u) { return u.btu; });
      var nDucted = state.units.filter(function (u) { return u.kind === 'ducted'; }).length;
      var ok = approvedUnits(state.cond, state.units) && state.units.every(function (u) { var h = handler(u.btu, u.kind); return h && h.available; });
      var label = sizes.map(function (s) { return s + 'K'; }).join(' + ');
      $('[data-matchcheck]').innerHTML = ok
        ? '<span class="match match--ok">✓ ' + label + ' is an MRCOOL-approved matchup for the ' + state.cond.btu + 'K condenser.</span>'
        : nDucted > 1 ? '<span class="match match--no">✗ One ducted Hybrid™ air handler per system. Switch the other ducted zone to wall-mount or cassette.</span>'
        : nDucted && !HYB[state.cond.sku] ? '<span class="match match--no">✗ The DIY Hybrid™ air handler pairs with the ' + hybridConds().join(', ') + ' condensers. Go back to step 2 and pick one of those, or switch this zone to wall-mount.</span>'
        : '<span class="match match--no">✗ ' + label + ' isn\'t on MRCOOL\'s approved list' + (nDucted ? ' for a Hybrid™ air handler' : '') + ' with the ' + state.cond.btu + 'K condenser. Adjust a size, or go back and pick another condenser.</span>';
      $('[data-next="4"]').disabled = !ok;
      $('[data-sum="3"]').textContent = state.units.map(function (u) { return u.btu + 'K' + (u.kind === 'cassette' ? ' cassette' : u.kind === 'ducted' ? ' ducted' : ''); }).join(' + ');
    }

    /* --- step 4 --- */
    function renderLines() {
      $('[data-lines]').innerHTML = state.rooms.map(function (r, i) {
        var u = state.units[i], L = state.lines[i];
        var chips = LENGTHS.map(function (len) {
          var o = lineOpts(u.btu, len); if (!o.cable && !o.plain) return '';
          return '<button type="button" class="chip" data-line="' + i + '" data-len="' + len + '" aria-current="' + (L.len === len) + '">' + len + ' ft</button>';
        }).join('') + '<button type="button" class="chip" data-line="' + i + '" data-len="0" aria-current="' + (L.len === 0) + '">None</button>';
        var o = L.len ? lineOpts(u.btu, L.len) : {}, both = o.cable && o.plain, ls = L.len ? lineFor(u.btu, L.len, L.cable) : null;
        return '<div class="zone zone--lines">' +
          '<span class="zone__name">' + esc(r.name) + '<small>' + u.btu + 'K · ' + LINE_SIZE[u.btu] + '" copper</small></span>' +
          '<div class="chips">' + chips + '</div>' +
          (L.len ? '<label class="cable"><input type="checkbox" data-cable="' + i + '"' + (L.cable ? ' checked' : '') + (both ? '' : ' disabled') + '> DIYPRO® cable' + (both ? '' : (L.cable ? ' (included)' : ' (n/a)')) + '</label>' : '<span class="muted" style="font-size:13px">Using your own line set</span>') +
          '<span class="zone__price">' + (ls ? money(ls.price) : '—') + '</span>' +
          '</div>';
      }).join('');
      var total = state.lines.reduce(function (a, l) { return a + l.len; }, 0), max = state.cond ? state.cond.maxLine : 0;
      $('[data-meter-fill]').style.width = (max ? Math.min(100, total / max * 100) : 0) + '%';
      $('[data-meter-left]').textContent = 'Total line length: ' + total + ' ft';
      $('[data-meter-right]').textContent = max ? 'Condenser max: ' + max + ' ft' : '';
      linesOk = !max || total <= max;
      $('[data-step4-msg]').textContent = linesOk ? '' : 'Over the condenser\'s maximum total line length.';
      $('[data-next="5"]').disabled = !linesOk;
      $('[data-sum="4"]').textContent = total + ' ft of copper';
    }

    /* --- step 5 --- */
    function renderAccs() {
      var vis = data.accessories.filter(accVisible);
      $('[data-accs]').innerHTML = vis.length ? vis.map(function (a) {
        var q = state.acc[a.id] || 0, rec = accRecommended(a);
        return '<div class="acc-card' + (q ? ' is-on' : '') + '">' +
          (a.image ? '<img src="' + a.image + '" alt="" loading="lazy">' : '<span></span>') +
          '<div class="acc-card__info">' + (rec ? '<span class="acc-card__rec">' + esc(accNote(a)) + '</span>' : '') +
          '<strong>' + esc(a.title) + '</strong><span class="muted">' + money(a.price) + (q > 1 ? ' × ' + q : '') + '</span></div>' +
          (q ? '<div class="qty qty--sm" data-acc="' + a.id + '"><button type="button" data-acc-step="-1" aria-label="Fewer">−</button><span>' + q + '</span><button type="button" data-acc-step="1" aria-label="More">+</button></div>'
             : '<button type="button" class="btn btn--sm btn--ghost" data-acc-add="' + a.id + '"' + (a.available ? '' : ' disabled') + '>Add</button>') +
          '</div>';
      }).join('') : '<p class="muted">No add-ons configured.</p>';
      var n = vis.filter(function (a) { return state.acc[a.id]; }).length;
      $('[data-sum="5"]').textContent = n ? n + ' add-on' + (n > 1 ? 's' : '') : 'No add-ons';
    }

    /* --- step 6 --- */
    function renderKit() {
      var items = lineItems();
      $('[data-kit]').innerHTML = items.map(function (it) {
        return '<a class="kit__item" href="' + esc(it.url) + '" target="_blank" rel="noopener">' +
          '<span class="kit__img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '<svg class="kit__ph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="2"/><path d="M20 12h3"/></svg>') + (it.qty > 1 ? '<span class="kit__qty">×' + it.qty + '</span>' : '') + '</span>' +
          '<span class="kit__label">' + esc(it.label) + '</span>' +
          '<span class="kit__price">' + money(it.price * it.qty) + '</span></a>';
      }).join('');
      $('[data-sum="6"]').textContent = items.reduce(function (a, i) { return a + i.qty; }, 0) + ' items';
    }

    /* --- summary --- */
    function summarize() {
      var items = lineItems(), total = 0;
      $('[data-summary-list]').innerHTML = items.length ? items.map(function (it) {
        total += it.price * it.qty;
        return '<li><span>' + esc(it.label) + (it.qty > 1 ? ' × ' + it.qty : '') + '</span><span>' + money(it.price * it.qty) + '</span></li>';
      }).join('') : '<li><span>Start by sizing your rooms.</span></li>';
      $('[data-summary-total]').textContent = money(total);
      var ready = state.step >= 5 && (single() ? !!state.bundle : linesOk);
      var cta = $('[data-builder-add]');
      cta.disabled = !ready;
      cta.textContent = ready ? 'Add system to cart' : ({ 1: 'Size your rooms to start', 2: single() ? 'Pick your kit' : 'Pick a condenser', 3: 'Choose air handlers', 4: 'Pick your copper' })[state.step];
      b._items = items.map(function (it) { return { id: it.id, quantity: it.qty }; });
    }

    function render() {
      renderRooms();
      if (state.step >= 2) renderStep2();
      if (!single() && state.step >= 3 && state.step !== 2) renderHandlers();
      if (!single() && state.step >= 4) renderLines();
      if (state.step >= 5) renderAccs();
      if (state.step >= 6) renderKit();
      summarize();
    }

    function resetFrom1() { state.cond = null; state.bundle = null; if (state.step > 1) go(1); else render(); }

    /* --- events --- */
    b.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.hasAttribute('data-room')) return;
      var r = state.rooms[Number(t.getAttribute('data-room'))];
      if (t.getAttribute('data-k') === 'name') { r.name = t.value; return; }
      r.sq = Number(t.value);
      t.closest('.room').querySelector('.room__need').textContent = r.sq ? need(r) + 'K' : '—';
      $('[data-next="2"]').disabled = !state.rooms.every(function (x) { return Number(x.sq) > 0; });
      if (state.step > 1) { state.cond = null; state.bundle = null; go(1); }
    });
    b.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'mz-ceiling' || t.name === 'mz-climate') resetFrom1();
      else if (t.hasAttribute('data-room') && t.getAttribute('data-k') === 'sq') renderRooms();
      else if (t.name === 'mz-kit') { state.bundle = data.bundles.find(function (k) { return String(k.id) === t.value; }); renderStep2(); summarize(); }
      else if (t.name === 'mz-cond') {
        state.cond = data.condensers.find(function (c) { return String(c.id) === t.value; });
        state.units = state.cond._fit.sizes.map(function (s) { return { btu: s, kind: hasKind(s, 'wall') ? 'wall' : 'cassette' }; });
        state.lines = state.units.map(function (u) { return defaultLine(u.btu); });
        $('[data-next="3"]').disabled = false;
        $('[data-sum="2"]').textContent = state.cond.btu + 'K · ' + state.cond.zones + '-zone condenser';
        summarize();
      }
      else if (t.hasAttribute('data-unit')) {
        var i = Number(t.getAttribute('data-unit')), u = state.units[i];
        if (t.getAttribute('data-k') === 'btu') { u.btu = Number(t.value); if (!hasKind(u.btu, u.kind)) u.kind = hasKind(u.btu, 'wall') ? 'wall' : 'cassette'; }
        else {
          u.kind = t.value;
          if (!hasKind(u.btu, u.kind)) {
            // Snap to the nearest size this style comes in (Hybrid is 24K/36K only).
            var opts = SIZES.filter(function (sz) { return hasKind(sz, u.kind); });
            u.btu = opts.filter(function (sz) { return sz >= u.btu; })[0] || opts[opts.length - 1];
          }
        }
        state.lines[i] = defaultLine(u.btu);
        renderHandlers(); summarize();
      }
      else if (t.hasAttribute('data-cable')) { state.lines[Number(t.getAttribute('data-cable'))].cable = t.checked; renderLines(); summarize(); }
    });
    b.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !b.contains(t) || t.disabled) return;
      if (t.hasAttribute('data-add-room')) {
        state.rooms.push({ name: ROOM_NAMES[state.rooms.length] || 'Room ' + (state.rooms.length + 1), sq: 0 });
        resetFrom1(); var ins = b.querySelectorAll('[data-k=sq]'); ins[ins.length - 1].focus();
      }
      else if (t.hasAttribute('data-remove-room')) { state.rooms.splice(Number(t.getAttribute('data-remove-room')), 1); resetFrom1(); }
      else if (t.hasAttribute('data-next')) {
        var n = Number(t.getAttribute('data-next'));
        if (n === 3 && single()) n = 5;
        go(n);
      }
      else if (t.hasAttribute('data-goto')) { var g = Number(t.getAttribute('data-goto')); if (seq().indexOf(g) < seq().indexOf(state.step)) go(g); }
      else if (t.hasAttribute('data-len')) {
        var i = Number(t.getAttribute('data-line')), len = Number(t.getAttribute('data-len')), L = state.lines[i];
        L.len = len;
        if (len) { var o = lineOpts(state.units[i].btu, len); if (L.cable && !o.cable) L.cable = false; if (!L.cable && !o.plain) L.cable = true; }
        renderLines(); summarize();
      }
      else if (t.hasAttribute('data-acc-add')) {
        var a = data.accessories.find(function (x) { return String(x.id) === t.getAttribute('data-acc-add'); });
        state.acc[a.id] = accDefaultQty(a); renderAccs(); summarize();
      }
      else if (t.hasAttribute('data-acc-step')) {
        var id = t.closest('[data-acc]').getAttribute('data-acc');
        state.acc[id] = Math.max(0, (state.acc[id] || 0) + Number(t.getAttribute('data-acc-step')));
        if (!state.acc[id]) delete state.acc[id];
        renderAccs(); summarize();
      }
      else if (t.hasAttribute('data-builder-add') || t.hasAttribute('data-builder-add2')) {
        if (!b._items || !b._items.length) return;
        var btns = b.querySelectorAll('[data-builder-add],[data-builder-add2]');
        btns.forEach(function (x) { x.disabled = true; x.textContent = 'Adding system…'; });
        S.addItems(b._items)
          .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
          .finally(function () { btns.forEach(function (x) { x.disabled = false; }); $('[data-builder-add2]').textContent = 'Add system to cart'; summarize(); });
      }
    });

    go(1);
  });

  /* ---------- Custom single-zone builder ---------- */
  document.querySelectorAll('[data-sz]').forEach(function (b) {
    var data = JSON.parse(b.querySelector('[data-sz-json]').textContent);
    var COVER = { 9: 350, 12: 500, 18: 750, 24: 1000, 36: 1500 };
    var LINE_SIZE = { 6: '1/4 x 3/8', 9: '1/4 x 3/8', 12: '1/4 x 3/8', 18: '1/4 x 1/2', 24: '3/8 x 5/8', 36: '3/8 x 5/8' };
    var INC = data.included || 25, MAXRUN = 75;
    var $ = function (s) { return b.querySelector(s); };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var money = formatMoney;
    data.condensers.sort(function (x, y) { return x.btu - y.btu; });
    var SIZES = data.condensers.map(function (c) { return c.btu; });
    var state = { step: 1, mode: 'sqft', btuPick: null, btu: null, run: INC, acc: {} };

    function factor() {
      var c = b.querySelector('input[name=sz-ceiling]:checked'), k = b.querySelector('input[name=sz-climate]:checked');
      return (c ? Number(c.value) : 1) * (k ? Number(k.value) : 1);
    }
    function recBtu() {
      if (state.mode === 'btu') return state.btuPick;
      var eff = Number($('[data-sz-sq]').value) * factor();
      for (var i = 0; i < SIZES.length; i++) if ((COVER[SIZES[i]] || 0) >= eff) return SIZES[i];
      return null;
    }
    function cond() { return data.condensers.find(function (c) { return c.btu === state.btu; }); }
    function handler() {
      var c = cond(); if (!c) return null;
      return data.handlers.find(function (h) { return h.btu === c.btu && h.volts === c.volts; }) || data.handlers.find(function (h) { return h.btu === c.btu; });
    }
    function kit() {
      var c = cond(); if (!c) return null;
      return (data.kits || []).find(function (k) { return k.btu === c.btu && k.volts === c.volts && k.available; }) || null;
    }
    function plan() {
      var ext = state.run - INC;
      if (ext <= 0) return { included: true };
      var size = LINE_SIZE[state.btu];
      var lens = data.linesets.filter(function (l) { return l.size === size && l.available; }).map(function (l) { return l.len; })
        .filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (x, y) { return x - y; });
      var len = lens.find(function (l) { return l >= ext && INC + l <= MAXRUN; });
      if (!len) return { tooLong: true };
      var ls = data.linesets.find(function (l) { return l.size === size && l.len === len && !l.cable && l.available; }) ||
               data.linesets.find(function (l) { return l.size === size && l.len === len && l.available; });
      var cp = data.couplers.find(function (c) { return c.fits.indexOf(state.btu) > -1 && c.available; });
      return { ext: ls, coupler: cp, total: INC + len };
    }
    function accVisible(a) {
      if (a.role === 'bracket-small') return state.btu && state.btu <= 18;
      if (a.role === 'bracket-large') return state.btu && state.btu >= 24;
      return true;
    }

    function items() {
      var list = [], c = cond(), h = handler(), k = kit();
      if (k) list.push({ id: k.id, label: k.btu + 'K complete kit (' + k.volts + ') · condenser, air handler, ' + INC + ' ft line set', price: k.price, qty: 1, image: k.image, url: k.url });
      else if (c) list.push({ id: c.id, label: c.btu + 'K condenser (' + c.volts + ') · incl. ' + INC + ' ft line set', price: c.price, qty: 1, image: c.image, url: c.url });
      if (h && !k) list.push({ id: h.id, label: h.btu + 'K wall-mount air handler (' + h.volts + ')', price: h.price, qty: 1, image: h.image, url: h.url });
      if (state.step >= 4 || state.step === 3) {
        var p = plan();
        if (p.ext) list.push({ id: p.ext.id, label: '+' + p.ext.len + ' ft ' + p.ext.size + ' extension line set', price: p.ext.price, qty: 1, image: p.ext.image, url: p.ext.url });
        if (p.coupler) list.push({ id: p.coupler.id, label: p.coupler.title, price: p.coupler.price, qty: 1, image: p.coupler.image, url: p.coupler.url });
      }
      data.accessories.forEach(function (a) { if (state.acc[a.id] && accVisible(a)) list.push({ id: a.id, label: a.title, price: a.price, qty: state.acc[a.id], image: a.image, url: a.url }); });
      return list;
    }

    function go(n) {
      state.step = n;
      b.querySelectorAll('[data-wstep]').forEach(function (el) {
        var k = Number(el.getAttribute('data-wstep'));
        el.classList.toggle('is-active', k === n); el.classList.toggle('is-done', k < n); el.classList.toggle('is-locked', k > n);
        el.querySelector('.wstep__head').disabled = k >= n;
      });
      render();
      if (n > 1) { var act = b.querySelector('[data-wstep="' + n + '"]'); window.scrollTo({ top: act.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); }
    }

    function render1() {
      var sq = Number($('[data-sz-sq]').value);
      $('[data-sz-sqout]').textContent = sq.toLocaleString() + ' sq ft';
      var r = $('[data-sz-sq]'); r.style.setProperty('--fill', ((sq - r.min) / (r.max - r.min) * 100) + '%');
      b.querySelector('[data-mode=sqft]').hidden = state.mode !== 'sqft';
      b.querySelector('[data-mode=btu]').hidden = state.mode !== 'btu';
      $('[data-sz-btus]').innerHTML = SIZES.map(function (s) {
        var c = data.condensers.find(function (x) { return x.btu === s; });
        return '<button type="button" class="chip" data-btu="' + s + '" aria-current="' + (state.btuPick === s) + '">' + s + 'K · ' + c.volts + '</button>';
      }).join('');
      var rb = recBtu();
      $('[data-sz-rec]').textContent = rb ? 'Recommended: ' + rb + 'K BTU' : (state.mode === 'btu' ? 'Pick a size.' : 'Over 1,500 sq ft — consider a multi-zone system.');
      $('[data-next="2"]').disabled = !rb;
      $('[data-sum="1"]').textContent = state.mode === 'btu' ? (state.btuPick ? state.btuPick + 'K BTU' : '') : sq.toLocaleString() + ' sq ft → ' + (rb ? rb + 'K' : '—');
    }
    function card(it, note) {
      return '<a class="kit__item" href="' + esc(it.url) + '" target="_blank" rel="noopener"><span class="kit__img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="kit__label">' + esc(it.label) + '</span>' + (note ? '<span class="kit__price">' + note + '</span>' : '') + '<span class="kit__price">' + money(it.price) + '</span></a>';
    }
    function render2() {
      var c = cond(), h = handler(), k = kit();
      $('[data-sz-pair]').innerHTML = k ?
        '<div class="kit">' + card({ label: k.btu + 'K DIY® 5th Gen complete kit', price: k.price, image: k.image, url: k.url }, k.volts + ' · condenser, matched air handler, ' + INC + ' ft pre-charged line set' + (k.compare > k.price ? ' · <s>' + money(k.compare) + '</s> on sale' : '')) + '</div>' +
        '<p class="muted" style="font-size:14px">Size: ' + k.btu + ',000 BTU · ' + (COVER[k.btu] ? 'rated for up to ' + COVER[k.btu].toLocaleString() + ' sq ft' : '') + '</p>'
        : (c && h) ?
        '<div class="kit">' + card({ label: c.btu + 'K outdoor condenser', price: c.price, image: c.image, url: c.url }, c.volts + ' · includes ' + INC + ' ft pre-charged line set') +
        '<span class="pair__plus" aria-hidden="true">+</span>' + card({ label: h.btu + 'K wall-mount air handler', price: h.price, image: h.image, url: h.url }, h.volts + ' · matched') + '</div>' +
        '<p class="muted" style="font-size:14px">Size: ' + c.btu + ',000 BTU · ' + (COVER[c.btu] ? 'rated for up to ' + COVER[c.btu].toLocaleString() + ' sq ft' : '') + '</p>'
        : '<p class="notice">That size isn\'t available right now — contact us.</p>';
      $('[data-next="3"]').disabled = !(k || (c && h && c.available && h.available));
      $('[data-sum="2"]').textContent = c ? c.btu + 'K condenser + air handler · ' + c.volts : '';
    }
    function render3() {
      var r = $('[data-sz-run]'); r.value = state.run;
      $('[data-sz-runout]').textContent = state.run + ' ft';
      r.style.setProperty('--fill', ((state.run - r.min) / (r.max - r.min) * 100) + '%');
      var p = plan(), html = '', ok = true;
      if (p.included) {
        html = '<div class="match match--ok">✓ The ' + INC + ' ft line set included with your condenser covers a ' + state.run + ' ft run. Nothing extra to buy.' + (state.run < INC ? ' The extra ' + (INC - state.run) + ' ft loops neatly behind the unit — never cut a pre-charged line.' : '') + '</div>';
      } else if (p.tooLong) {
        ok = false; html = '<div class="match match--no">Runs over ' + MAXRUN + ' ft need a custom plan. Email us your layout and we\'ll spec it.</div>';
      } else if (!p.ext || !p.coupler) {
        ok = false; html = '<div class="match match--no">We don\'t have the right extension in stock for that length — contact us.</div>';
      } else {
        html = '<div class="lineplan">' +
          '<div class="lineplan__bar"><span style="flex:' + INC + '">' + INC + ' ft included</span><i></i><span style="flex:' + p.ext.len + '" class="is-ext">+' + p.ext.len + ' ft extension</span></div>' +
          '<p><strong>' + p.total + ' ft total</strong> covers your ' + state.run + ' ft run. We\'ll add a ' + p.ext.len + ' ft ' + p.ext.size + '" pre-charged extension plus the matching DIY® coupler kit (' + money(p.coupler.price) + ', includes 75 ft of DIYPRO® cable) to join them.</p></div>';
      }
      $('[data-sz-lineplan]').innerHTML = html;
      $('[data-next="4"]').disabled = !ok;
      $('[data-sz-runmsg]').textContent = ok ? '' : '';
      $('[data-sum="3"]').textContent = state.run + ' ft run' + (p.total ? ' · ' + p.total + ' ft of line' : '');
      return ok;
    }
    function render4() {
      var list = items();
      $('[data-kit]').innerHTML = list.map(function (it) {
        return '<a class="kit__item" href="' + esc(it.url) + '" target="_blank" rel="noopener"><span class="kit__img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '<svg class="kit__ph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="2"/><path d="M20 12h3"/></svg>') + (it.qty > 1 ? '<span class="kit__qty">×' + it.qty + '</span>' : '') + '</span>' +
          '<span class="kit__label">' + esc(it.label) + '</span><span class="kit__price">' + money(it.price * it.qty) + '</span></a>';
      }).join('');
      var vis = data.accessories.filter(accVisible);
      $('[data-sz-accs-wrap]').hidden = !vis.length;
      $('[data-accs]').innerHTML = vis.map(function (a) {
        var q = state.acc[a.id] || 0;
        var rec = a.role === 'cover' ? 'Recommended' : (a.role.indexOf('bracket') === 0 ? 'Fits your ' + state.btu + 'K condenser' : '');
        return '<div class="acc-card' + (q ? ' is-on' : '') + '">' + (a.image ? '<img src="' + a.image + '" alt="" loading="lazy">' : '<span></span>') +
          '<div class="acc-card__info">' + (rec ? '<span class="acc-card__rec">' + rec + '</span>' : '') + '<strong>' + esc(a.title) + '</strong><span class="muted">' + money(a.price) + '</span></div>' +
          (q ? '<div class="qty qty--sm" data-acc="' + a.id + '"><button type="button" data-acc-step="-1" aria-label="Fewer">−</button><span>' + q + '</span><button type="button" data-acc-step="1" aria-label="More">+</button></div>'
             : '<button type="button" class="btn btn--sm btn--ghost" data-acc-add="' + a.id + '"' + (a.available ? '' : ' disabled') + '>Add</button>') + '</div>';
      }).join('');
      $('[data-sum="4"]').textContent = list.length + ' items';
    }
    function summarize() {
      var list = state.step >= 2 ? items() : [], total = 0;
      $('[data-summary-list]').innerHTML = list.length ? list.map(function (it) { total += it.price * it.qty; return '<li><span>' + esc(it.label) + (it.qty > 1 ? ' × ' + it.qty : '') + '</span><span>' + money(it.price * it.qty) + '</span></li>'; }).join('') : '<li><span>Start by sizing your space.</span></li>';
      $('[data-summary-total]').textContent = money(total);
      var ready = state.step === 4, cta = $('[data-sz-add]');
      cta.disabled = !ready;
      cta.textContent = ready ? 'Add system to cart' : ['', 'Size your space to start', 'Confirm your units', 'Measure your line run'][state.step];
      b._items = list.map(function (it) { return { id: it.id, quantity: it.qty }; });
    }
    function render() {
      render1();
      if (state.step >= 2) render2();
      if (state.step >= 3) render3();
      if (state.step >= 4) render4();
      summarize();
    }

    b.addEventListener('input', function (e) {
      if (e.target.matches('[data-sz-sq]')) { if (state.step > 1) go(1); else { render1(); } }
      if (e.target.matches('[data-sz-run]')) { state.run = Number(e.target.value); render3(); summarize(); }
    });
    b.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'sz-mode') { state.mode = t.value; if (state.step > 1) go(1); else render1(); }
      if (t.name === 'sz-ceiling' || t.name === 'sz-climate') { if (state.step > 1) go(1); else render1(); }
    });
    b.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !b.contains(t) || t.disabled) return;
      if (t.hasAttribute('data-btu')) { state.btuPick = Number(t.getAttribute('data-btu')); if (state.step > 1) go(1); else render1(); }
      else if (t.hasAttribute('data-next')) { var n = Number(t.getAttribute('data-next')); if (n === 2) state.btu = recBtu(); go(n); }
      else if (t.hasAttribute('data-goto')) { var g = Number(t.getAttribute('data-goto')); if (g < state.step) go(g); }
      else if (t.hasAttribute('data-acc-add')) { var id = t.getAttribute('data-acc-add'), a = data.accessories.find(function (x) { return String(x.id) === id; }); state.acc[a.id] = 1; render4(); summarize(); }
      else if (t.hasAttribute('data-acc-step')) { var aid = t.closest('[data-acc]').getAttribute('data-acc'); state.acc[aid] = Math.max(0, (state.acc[aid] || 0) + Number(t.getAttribute('data-acc-step'))); if (!state.acc[aid]) delete state.acc[aid]; render4(); summarize(); }
      else if (t.hasAttribute('data-sz-add') || t.hasAttribute('data-sz-add2')) {
        if (!b._items || !b._items.length) return;
        var btns = b.querySelectorAll('[data-sz-add],[data-sz-add2]');
        btns.forEach(function (x) { x.disabled = true; x.textContent = 'Adding…'; });
        S.addItems(b._items)
          .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
          .finally(function () { btns.forEach(function (x) { x.disabled = false; }); $('[data-sz-add2]').textContent = 'Add system to cart'; summarize(); });
      }
    });
    go(1);
  });
})();

/* ---------- Share cart / quote links ---------- */
(function () {
  'use strict';
  var S = window.Summit || {};
  var routes = S.routes || {};
  var root = (routes.root || '/').replace(/\/?$/, '/');
  var cartUrl = routes.cart_url || '/cart';
  var money = S.formatMoney || function (c) { return '$' + (c / 100).toFixed(2); };
  var KEY = 'mcQuoteResult';

  function req(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    });
  }
  function encode(items) {
    return items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
  }
  function decode(s) {
    return (s || '').split(',').map(function (p) {
      var a = p.split(':');
      return { id: parseInt(a[0], 10), quantity: Math.max(1, Math.min(99, parseInt(a[1], 10) || 1)) };
    }).filter(function (i) { return i.id > 0; }).slice(0, 50);
  }

  /* Build + share a link from the live cart */
  var box = document.querySelector('[data-share-cart]');
  if (box) {
    var out = box.querySelector('[data-share-cart-out]');
    var input = box.querySelector('[data-share-cart-url]');
    var copyBtn = box.querySelector('[data-share-cart-copy]');
    var email = box.querySelector('[data-share-cart-email]');
    function copy() {
      input.select();
      var done = function () { copyBtn.textContent = 'Copied ✓'; setTimeout(function () { copyBtn.textContent = 'Copy link'; }, 2200); };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(input.value).then(done, function () { document.execCommand('copy'); done(); });
      else { document.execCommand('copy'); done(); }
    }
    box.querySelector('[data-share-cart-btn]').addEventListener('click', function () {
      req(root + 'cart.js').then(function (cart) {
        if (!cart.items.length) return;
        var url = location.origin + cartUrl + '?quote=' + encode(cart.items);
        input.value = url;
        out.hidden = false;
        var lines = cart.items.map(function (i) { return i.quantity + ' × ' + i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' (' + i.variant_title + ')' : '') + ' — ' + money(i.final_line_price); });
        var body = 'Here is the system I put together on Mountain Cool:\n\n' + lines.join('\n') +
          '\n\nSubtotal: ' + money(cart.total_price) + ' (free shipping; taxes at checkout)\n\nOpen this link to load it into a cart:\n' + url;
        email.href = 'mailto:?subject=' + encodeURIComponent('Mountain Cool quote') + '&body=' + encodeURIComponent(body);
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          navigator.share({ title: 'Mountain Cool quote', text: 'Mountain Cool quote: ' + money(cart.total_price), url: url }).catch(function () {});
        } else {
          copy();
        }
      });
    });
    copyBtn.addEventListener('click', copy);
  }

  /* Load a shared link: /cart?quote=VARIANT:QTY,VARIANT:QTY */
  var q = new URLSearchParams(location.search).get('quote');
  if (q) {
    var items = decode(q);
    if (items.length) {
      var veil = document.createElement('div');
      veil.className = 'quote-veil';
      veil.innerHTML = '<div class="quote-veil__card"><span class="quote-veil__spin"></span>Loading your quote…</div>';
      document.body.appendChild(veil);
      req(root + 'cart/clear.js', {})
        .then(function () {
          return req(root + 'cart/add.js', { items: items }).then(function () { return []; }, function () {
            // One bad item rejects the whole batch: add one at a time and note what failed.
            var failed = [];
            return items.reduce(function (p, it) {
              return p.then(function () { return req(root + 'cart/add.js', { items: [it] }).catch(function () { failed.push(it.id); }); });
            }, Promise.resolve()).then(function () { return failed; });
          });
        })
        .then(function (failed) {
          try { sessionStorage.setItem(KEY, JSON.stringify({ n: items.length, failed: failed.length })); } catch (e) {}
          location.replace(cartUrl);
        }, function () { location.replace(cartUrl); });
      return;
    }
  }

  /* Banner after a quote loads */
  var res = null;
  try { res = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) {}
  if (res) {
    var head = document.querySelector('.collection-hero');
    if (head) {
      var p = document.createElement('p');
      p.className = 'notice quote-notice' + (res.failed ? ' notice--error' : '');
      p.setAttribute('role', 'status');
      p.textContent = res.failed
        ? 'Your quote is loaded, but ' + res.failed + ' item' + (res.failed > 1 ? 's are' : ' is') + ' no longer available. Questions? Contact us and we\'ll sort it out.'
        : 'Your quote is loaded. Review it below and check out when you\'re ready.';
      head.appendChild(p);
    }
  }

  // Lite YouTube: thumbnail link that swaps to a player on click
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.yt[data-yt]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + a.getAttribute('data-yt') + '?autoplay=1&rel=0' + (a.getAttribute('data-start') ? '&start=' + a.getAttribute('data-start') : '');
    f.title = a.getAttribute('aria-label') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    a.replaceWith((function () { var d = document.createElement('div'); d.className = 'yt'; d.appendChild(f); return d; })());
  });

  // Install guide: highlight current step in the table of contents, remember checklist ticks
  (function () {
    var toc = document.querySelectorAll('[data-guide-toc] a[href^="#"]');
    if (toc.length && 'IntersectionObserver' in window) {
      var map = {};
      toc.forEach(function (a) { var k = a.getAttribute('href').slice(1); (map[k] = map[k] || []).push(a); });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && map[en.target.id]) {
            toc.forEach(function (a) { a.classList.remove('is-active'); });
            map[en.target.id].forEach(function (a) { a.classList.add('is-active'); });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
    }
    document.querySelectorAll('[data-gcheck] input[type=checkbox]').forEach(function (cb) {
      var key = 'mc-guide:' + location.pathname + ':' + cb.id;
      try { cb.checked = localStorage.getItem(key) === '1'; } catch (err) {}
      cb.addEventListener('change', function () { try { localStorage.setItem(key, cb.checked ? '1' : '0'); } catch (err) {} });
    });
  })();

  // Install handbook popup: once per 14 days, never after signup; opens after a delay, at half-page scroll, or on exit intent
  (function () {
    var dlg = document.querySelector('[data-hb-pop]');
    var KEY = 'mc-hb-pop';
    function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    var posted = /customer_posted=true/.test(location.search);
    if (posted) set({ done: true });
    if (!dlg || typeof dlg.showModal !== 'function') return;
    function open() {
      if (dlg.open || document.querySelector('dialog[open]:not([data-hb-pop])')) return;
      dlg.showModal(); set({ until: Date.now() + 14 * 864e5 });
      cleanup();
    }
    if (posted && location.hash === '#handbook-popup') { dlg.showModal(); }
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-hb-close]')) dlg.close(); });
    var st = get();
    if (posted || st.done || (st.until && st.until > Date.now())) return;
    var t = setTimeout(open, (Number(dlg.getAttribute('data-delay')) || 15) * 1000);
    function onScroll() { if (window.scrollY > (document.documentElement.scrollHeight - innerHeight) * 0.5 && window.scrollY > 600) open(); }
    function onLeave(e) { if (e.clientY <= 0 && !e.relatedTarget) open(); }
    function cleanup() { clearTimeout(t); window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onLeave);
  })();
})();
